export default "__VITE_ASSET__D5Wx8wSa__"